import { FleekError } from './FleekError';

type MaintenanceErrorOptions = Record<string, never>;

export class MaintenanceError extends FleekError<MaintenanceErrorOptions> {
  public name = 'MaintenanceError';

  public extensions = {
    http: {
      status: 503, // Service Unavailable
    },
  };

  constructor() {
    super({});
  }

  toString = () => 'The platform is under maintenance. Please try again later.';
}
